import React from 'react';
import { removeParameterFromUrl } from '../../../utils/helper';

const sort = (props, ev) => {
  let modifiedLocation = '';
  const { categoryActions, categoryId, location, order } = props;
  if (location.hash.includes('dir')) {
    let loc = null;
    if (location.hash.split('dir')[0].length > 0) {
      loc = location.hash.slice(
        location.hash.lastIndexOf('dir') - 1,
        location.hash.lastIndexOf('true') + 4
      );
    } else {
      loc = location.hash.slice(
        location.hash.lastIndexOf('dir'),
        location.hash.lastIndexOf('true') + 4
      );
    }
    location.hash.split(loc).forEach(value => {
      modifiedLocation += value;
    });
  } else {
    modifiedLocation = location.hash;
  }
  if (!location.hash.includes('dir') && location.hash.includes('&gan_data=true')) {
    modifiedLocation = modifiedLocation.replace('&gan_data=true', '');
  }
  let tempString = '';
  if (modifiedLocation.length > 2) {
    if (modifiedLocation.includes('#')) {
      modifiedLocation = modifiedLocation.split('#')[1];
    }
    const tempLocat = modifiedLocation.split('&');
    tempLocat.forEach(val => {
      tempString = `${tempString}filter_${val}&`;
    });
  } else {
    tempString = modifiedLocation;
  }
  if (
    modifiedLocation.length > 30 &&
    modifiedLocation.length < 42 &&
    modifiedLocation.includes('dir')
  ) {
    tempString = modifiedLocation;
  }
  const selected = [...ev.target].filter(option => option.selected).map(option => option.value);
  if (window.dtm.LenskartRewamp)
    window.dtm.LenskartRewamp.Listing.sort.applySortingOnProduct(selected[0]);
  let mystring = '';
  if (tempString.length < 2) {
    modifiedLocation = `${modifiedLocation}#dir=${order}&sort=${selected[0]}&gan_data=true`;
    mystring = `${tempString}dir=${order}&sort=${selected[0]}&gan_data=true`;
  } else {
    modifiedLocation = `${modifiedLocation}&dir=${order}&sort=${selected[0]}&gan_data=true`;
    mystring = `${tempString}dir=${order}&sort=${selected[0]}&gan_data=true`;
  }
  const temp = {};
  temp.location = location;
  if (!modifiedLocation.includes('#')) {
    if (window.location.href?.indexOf('page=') !== -1) {
      const removePageParam = removeParameterFromUrl(window.location.href, 'page');
      history.pushState(window.location.href, null, `${removePageParam}#${modifiedLocation}`);
    } else {
      history.pushState('', '', `#${modifiedLocation}`);
    }
    temp.location.hash = `#${modifiedLocation}`;
  } else {
    if (window.location.href?.indexOf('page=') !== -1) {
      const removePageParam = removeParameterFromUrl(window.location.href, 'page');
      history.pushState(window.location.href, null, `${removePageParam}${modifiedLocation}`);
    } else {
      history.pushState('', '', `${modifiedLocation}`);
    }
    temp.location.hash = `${modifiedLocation}`;
  }
  temp.order = selected[0];
  window.scrollTo(0, 0);
  categoryActions.modifyData(temp);
  // history.replaceState(`${location.pathname}${location.hash}`, null, location.pathname + `${location.hash}`);
  categoryActions.loadCatAndFilterData(categoryId, mystring, 0);
};

const SortFilter = props => {
  const {
    dataLocale: {
      SORT_BY,
      BIGGEST_SAVING,
      MOST_VIEWED,
      NEW,
      PRICE_HIGH_TO_LOW,
      PRICE_LOW_TO_HIGH,
      BEST_SELLERS,
    },
  } = props;
  return (
    <div className="sort-by-wrap sorting col-sm-3 text-right pull-right">
      <span className="sort-by">
        <i aria-hidden="true" className="margin-minus fa fa-long-arrow-up"></i>
        <i aria-hidden="true" className="margin-r0 fa fa-long-arrow-down"></i>
        {SORT_BY}{' '}
      </span>
      <select className="select-lk" value={props.sortFilterValue} onChange={ev => sort(props, ev)}>
        <option value="best_sellers">{BEST_SELLERS}</option>
        <option value="low_price">{PRICE_LOW_TO_HIGH}</option>
        <option value="high_price">{PRICE_HIGH_TO_LOW}</option>
        <option value="created">{NEW}</option>
        <option value="saving">{BIGGEST_SAVING}</option>
        <option value="popular">{MOST_VIEWED}</option>
      </select>
    </div>
  );
};

export default SortFilter;
